var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeadache = function SvgHeadache(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.946 3.471A8.6 8.6 0 0 0 12 3.251C7.2 3.25 3.25 7.2 3.25 12S7.2 20.75 12 20.75s8.75-3.95 8.75-8.75a8.6 8.6 0 0 0-.675-3.353.75.75 0 1 0-1.383.58A7.15 7.15 0 0 1 19.25 12c0 3.978-3.272 7.25-7.25 7.25S4.75 15.977 4.75 12c0-3.979 3.272-7.25 7.25-7.25a7 7 0 0 1 1.61.182.75.75 0 0 0 .337-1.462z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.108 11.847a2.03 2.03 0 0 0 1.692.908c.68 0 1.316-.343 1.692-.909a.75.75 0 1 0-1.25-.829.53.53 0 0 1-.884 0 .75.75 0 1 0-1.25.83m6.4 0a2.03 2.03 0 0 0 1.692.908c.68 0 1.316-.343 1.692-.909a.75.75 0 0 0-1.25-.829.53.53 0 0 1-.884 0 .75.75 0 1 0-1.25.83m3.366-5.69 3-3.374a.75.75 0 1 1 1.121.996l-5 5.626-.457-2.279-1.494 2.091a.75.75 0 1 1-1.22-.872l3.506-4.909zM10.4 17.017h3.2a.75.75 0 0 0 0-1.5h-3.2a.75.75 0 0 0 0 1.5",
    clipRule: "evenodd"
  })));
};
export default SvgHeadache;